import { Link, type LinkProps } from "react-router";
import { usePcOnly } from "../lib/pcOnly.js";

/**
 * PC 専用の機能への入口のリンク（#185、docs/74 §1）。道が contract の PC_ONLY_FEATURES に当たれば、スマホでは出さない
 * （画面の中の「料金プラン表示」など。メニューの行は各メニューが usePcOnly().hidden を通す）
 */
export function PcLink(props: LinkProps & { to: string }) {
  const pcOnly = usePcOnly();
  return pcOnly.hidden(props.to) ? null : <Link {...props} />;
}
